/**
 * Spinner — small accent-coloured spinner for in-table loading states,
 * button loading indicators, etc.
 *
 * Props:
 *   size — pixel dimension; defaults to 18
 *   className — extra Tailwind classes
 */

export default function Spinner({ size = 18, className = '' }) {
  return (
    <span
      className={`inline-block rounded-full border-2 border-slate-200 animate-spin ${className}`}
      style={{
        width: size,
        height: size,
        borderTopColor: 'var(--accent)',
      }}
      role="status"
      aria-label="Loading"
    />
  );
}